/**
 * Shared translations
 *
 * This file contains translations for shared elements used across the app.
 */

import { SharedTranslationType } from './types';

// English translations
export const enShared: SharedTranslationType = {
    shared: {
        time: {
            justNow: "just now",
            minutesAgo: "{{count}} minutes ago",
            minuteAgo: "1 minute ago",
            hoursAgo: "{{count}} hours ago",
            hourAgo: "1 hour ago",
            daysAgo: "{{count}} days ago",
            dayAgo: "1 day ago",
            monthsAgo: "{{count}} months ago",
            monthAgo: "1 month ago",
            yearsAgo: "{{count}} years ago",
            yearAgo: "1 year ago"
        },
        participants: {
            all: "All participants"
        },
        participantPicker: {
            countSelected: "{{selected}}/{{total}} people",
            pickAtLeastOne: "Pick at least one person",
            perPerson: "{{amount}} each",
            shareRatio: "Pays {{ratio}}% of a full share",
            everyone: "Everyone",
            onlyMe: "Only me",
            clear: "Clear"
        }
    }
};

// Vietnamese translations
export const viShared: SharedTranslationType = {
    shared: {
        time: {
            justNow: "vừa xong",
            minutesAgo: "{{count}} phút trước",
            minuteAgo: "1 phút trước",
            hoursAgo: "{{count}} giờ trước",
            hourAgo: "1 giờ trước",
            daysAgo: "{{count}} ngày trước",
            dayAgo: "1 ngày trước",
            monthsAgo: "{{count}} tháng trước",
            monthAgo: "1 tháng trước",
            yearsAgo: "{{count}} năm trước",
            yearAgo: "1 năm trước"
        },
        participants: {
            all: "Tất cả mọi người"
        },
        participantPicker: {
            countSelected: "{{selected}}/{{total}} người",
            pickAtLeastOne: "Chọn ít nhất 1 người",
            perPerson: "{{amount}}/người",
            shareRatio: "Trả {{ratio}}% so với một suất đầy đủ",
            everyone: "Tất cả",
            onlyMe: "Chỉ mình tôi",
            clear: "Bỏ chọn"
        }
    }
};